import { render, staticRenderFns } from "./UpdateGoodsPrice.vue?vue&type=template&id=3283060f&scoped=true&"
import script from "./UpdateGoodsPrice.vue?vue&type=script&lang=ts&"
export * from "./UpdateGoodsPrice.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateGoodsPrice.vue?vue&type=style&index=0&id=3283060f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3283060f",
  null
  
)

export default component.exports